const reactAppApiURl = process.env.REACT_APP_API_URL;
const nodeEnv = process.env.REACT_APP_CONFIG_ENV;

// auth0 configuration
const auth0Domain = process.env.REACT_APP_AUTH0_DOMAIN;
const auth0ProjectUrl = process.env.REACT_APP_AUTH0_PROJECT_URL;
const auth0ClientId = process.env.REACT_APP_AUTH0_CLIENT_ID;
const auth0Audience = process.env.REACT_APP_AUTH0_AUDIENCE;
const auth0Connection = process.env.REACT_APP_AUTH0_CONNECTION;
const auth0Organization = process.env.REACT_APP_AUTH0_ORGANIZATION;
// Sentry configuration
const sentryEnabled = process.env.REACT_APP_SENTRY_ENABLED;
const sentryDsn = process.env.REACT_APP_SENTRY_DSN;
const sentryEnvironment = process.env.REACT_APP_SENTRY_ENVIRONMENT;
// Store
const storeId = process.env.REACT_APP_STORE_ID;
// Data url
const matchRulesUrl = process.env.REACT_APP_MATCH_RULES_URL;

const businessCaseUrl = process.env.REACT_APP_BUSINESS_CASE_URL;

const slackNotificationsUrl = process.env.REACT_APP_SLACK_NOTIFICATIONS_URL;

export default {
  nodeEnv,
  reactAppApiURl,
  auth0Domain,
  auth0ProjectUrl,
  auth0ClientId,
  auth0Audience,
  auth0Connection,
  auth0Organization,
  sentryEnabled,
  sentryDsn,
  sentryEnvironment,
  storeId,
  matchRulesUrl,
  businessCaseUrl,
  slackNotificationsUrl
};
